// hooks/useTelegram.js
import { useState, useEffect } from 'react';
import { getTelegramInitData, getTelegramLaunchUser } from '../utils/telegramInitData';

export const useTelegram = () => {
    const [userId, setInternalUserId] = useState(null); // внутренний ID из БД
    const [telegramId, setTelegramId] = useState(null);
    const [user, setUser] = useState(null);
    const [isTelegram, setIsTelegram] = useState(false);
    const [isWeb, setIsWeb] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const webApp = window.Telegram?.WebApp;
        const signedInitData = getTelegramInitData();
        const tgUser = getTelegramLaunchUser(signedInitData);
        const hasSignedInitData = signedInitData.length > 0;

        if (hasSignedInitData && tgUser && tgUser.id) {
            console.log('✅ Telegram пользователь:', tgUser);
            setIsTelegram(true);
            setIsWeb(false);
            setTelegramId(Number(tgUser.id));

            // Получаем внутренний ID пользователя из бэкенда
            fetch(`/api/user/by-telegram/${tgUser.id}`)
                .then(res => res.json())
                .then(data => {
                    if (data.success && data.user) {
                        setInternalUserId(data.user.id);
                        setUser({
                            id: data.user.id,
                            telegram_id: tgUser.id,
                            username: data.user.username,
                            first_name: data.user.first_name,
                            last_name: data.user.last_name,
                            language_code: data.user.language_code,
                            is_premium: data.user.is_premium
                        });
                    }
                })
                .catch(err => console.error('Ошибка получения пользователя:', err))
                .finally(() => setLoading(false));
        } else {
            // Эта сборка предназначена только для Telegram Mini App.
            // initDataUnsafe без подписанной строки initData не считается входом.
            setIsTelegram(false);
            setIsWeb(false);
            setInternalUserId(null);
            setTelegramId(null);
            setUser(null);
            setLoading(false);
        }
    }, []);

    const sendData = (data) => {
        if (window.Telegram?.WebApp) {
            window.Telegram.WebApp.sendData(JSON.stringify(data));
        }
    };

    return {
        userId,           // внутренний users.id
        telegramId,       // настоящий Telegram ID
        user,
        username: user?.username || null,
        loading,
        sendData,
        tg: window.Telegram?.WebApp,
        isTelegram,
        isWeb
    };
};
